<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title>
        摄像头管理
        <template slot="operate">
          <el-button
            class="g-form-section-search operate__item"
            title="导入"
            v-if="operationSuper.导入"
            icon="e6-icon-Import_fill"
            @click="openImport"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
        @resetForm="handleResetForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.cameraIdList">
            <e6Select
              :dataList="cameraList"
              :filterable="true"
              slotTemplate="tree"
              :issingleleaf="true"
              :disabledNoCheck="true"
              multiple
              ref="cameraTreeSelect"
              :placeholder="'选择摄像头'"
              @multipleSelect="handleSelectCamera"
            ></e6Select>
          </el-form-item>
          <el-form-item prop="forms.cameraCode">
            <el-input
              v-model="slotForms.forms.cameraCode"
              placeholder="摄像头编号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item prop="forms.onlineStatus">
            <el-select
              v-model="slotForms.forms.onlineStatus"
              clearable
              filterable
              placeholder="在线状态"
            >
              <el-option
                v-for="item in statusOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="forms.nvrCode">
            <el-input
              v-model="slotForms.forms.nvrCode"
              placeholder="输入NVR编码"
              clearable
            ></el-input>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="loading"
        ref="multipleTable"
        border
        :data="tableData"
        @sort-change="sortable"
        height="100%"
      >
        <div slot="empty" class="figure-data">
          <div class="nodate">
            <img src="../../../assets/images/pg-nodata.png" alt="" />
          </div>
        </div>
        <el-table-column
          label="序号"
          width="60"
          header-align="center"
          align="center"
          fixed
          type="index"
        ></el-table-column>
        <el-table-column
          label="摄像头名称"
          min-width="180"
          sortable="custom"
          header-align="center"
          align="left"
          :show-overflow-tooltip="true"
          prop="cameraName"
        ></el-table-column>
        <el-table-column
          label="摄像头编号"
          sortable="custom"
          min-width="180"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="cameraCode"
        ></el-table-column>
        <el-table-column
          label="使用对象"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="usingObj"
        >
        </el-table-column>
        <el-table-column
          label="所属企业"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="orgNameStr"
        >
        </el-table-column>
        <el-table-column
          label="采集时间"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="gpsTimeStr"
        >
        </el-table-column>
        <el-table-column
          label="在线状态"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="onlineStatusStr"
        >
        </el-table-column>
        <el-table-column
          label="绑定NVR"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="nvrName"
        >
        </el-table-column>
        <el-table-column
          label="IPC国标编码"
          min-width="120"
          header-align="center"
          :show-overflow-tooltip="true"
          align="left"
          prop="ipcCode"
        >
        </el-table-column>
        <el-table-column
          label="操作"
          min-width="120"
          fixed="right"
          :show-overflow-tooltip="true"
          header-align="center"
          align="center"
        >
          <template slot-scope="{ row }">
            <el-button type="text" @click="openCamera(row)">设置</el-button>
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!--摄像头设置-->
    <el-dialog
      class="dialog-css"
      title="摄像头设置"
      :visible.sync="dialogCameraVisible"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="500px"
      center
      @close="closeCamera"
    >
      <el-form :model="cameraObj" ref="camera" :rules="rules">
        <el-form-item label="摄像头编号" label-width="90px">
          <span>{{ cameraObj.cameraCode }}</span>
        </el-form-item>
        <el-form-item label="摄像头名称" label-width="90px" prop="cameraName">
          <el-input v-model="cameraObj.cameraName"></el-input>
        </el-form-item>
        <!-- <el-form-item label="使用对象" label-width="90px" prop="usingObj">
            <el-input v-model="cameraObj.usingObj" ></el-input>
          </el-form-item> -->
        <el-form-item label="所属企业" label-width="90px" prop="companyId">
          <el-select
            width="100%"
            v-model="cameraObj.companyId"
            filterable
            placeholder="所属企业"
          >
            <el-option
              v-for="item in comparyOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="使用对象" label-width="90px">
          <e6Select
            :dataList="storageOptions"
            :filterable="true"
            slotTemplate="tree"
            :issingleleaf="true"
            :disabledNoCheck="true"
            ref="storageTreeSelect"
            :placeholder="'使用对象'"
            @multipleSelect="handleSelStorage"
          ></e6Select>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeCamera">取 消</el-button>
        <el-button type="primary" @click="saveSetting('camera')">
          保存</el-button
        >
      </span>
    </el-dialog>
    <!--导入弹框-->
    <upload-center
      ref="addGoodsFile"
      :visible.sync="dialogImportVisible"
      :initInfo="importParams"
    ></upload-center>
  </div>
</template>

<script>
import {
  FetchCameraManageList,
  saveSettingCameraManage,
  cameraNameIsExist,
  FetchCameraListData,
  exportCamera
} from "@/api/systemSetting/cameraManager";
import { FetchStorageList } from "@/api/report/dangerous";
import { FetchAllComparys } from "_private/api/systemSetting/userManage";
import { mapGetters, mapActions } from "vuex";
import resizeListener from "_private/mixins/resizeListener";
import operationManage from "_private/mixins/operationManage";
import { mergeFormExtend } from "_private/utils/merge";
import { exportXlsx } from "@/utils/exportXlsx.js";
import uploadCenter from "@/components/uploadCenter";
import { cloneDeep } from "lodash";

export default {
  mixins: [resizeListener, operationManage],
  data() {
    // 摄像头名称
    let _this_ = this;
    var cameraNameValidator = (rule, value, callback) => {
      _this_.checkExistFun(rule, value, callback, _this_.cameraNameMsg);
    };
    return {
      total: 0,
      curPage: 1,
      pageSize: 20,
      isSearch: false,
      formExtend: {
        forms: {
          cameraCode: "", // 摄像头编号
          nvrCode: "",
          onlineStatus: "",
          cameraIdList: []
        },
        extends: []
      },
      formsExtend: [],
      storageOptions: [],
      comparyOptions: [],
      dangerousOptions: [
        {
          label: "未戴口罩",
          value: 1
        },
        {
          label: "未穿防护服",
          value: 2
        }
      ],
      statusOptions: [
        {
          label: "在线",
          value: 1
        },
        {
          label: "不在线",
          value: 0
        }
      ],
      cameraList: [],
      tableData: [],
      loading: "false",
      //导出URL
      exportUrl: "/report/storage/info/exportStorageAlarmInfo?",
      // 设置弹框
      dialogCameraVisible: false,
      oldCameraName: "",
      cameraObj: {},
      rules: {
        cameraName: [
          { max: 32, message: "不可超过32位", trigger: "blur" },
          { validator: cameraNameValidator }
        ],
        companyId: [
          { required: true, message: "请选择所属企业", trigger: "blur" }
        ]
      },
      // 校验重复的信息
      cameraNameMsg: "",
      // 导入相关
      dialogImportVisible: false,
      importParams: {
        title: "导入摄像头",
        templateUrl: "/excel/摄像头导入模板.xlsx",
        importUrl: "/base/camera/import"
      }
    };
  },
  components: { uploadCenter },
  computed: {
    ...mapGetters(["moduleId", "searchFormIsOpen", "userId"])
  },
  created() {
    // 查询列表数据
    this.FetchFindByPage(this.mergeObj());
    this.setSearchFormIsOpenAct();
    this.FetchCameraList();
    this.FetchComparyList();
    this.FetchStorageList();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    // 获取企业名称下拉
    FetchComparyList() {
      FetchAllComparys()
        .then(res => {
          if (res.result && res.result && Array.isArray(res.result)) {
            this.comparyOptions = res.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取仓库下拉
    FetchStorageList() {
      FetchStorageList()
        .then(response => {
          if (response.code == 1 && response.result) {
            this.storageOptions = response.result;
          } else {
            this.$message({
              message: response.message,
              type: "error"
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取摄像头下拉
    FetchCameraList() {
      FetchCameraListData({ onlineStatus: -1 })
        .then(res => {
          if (res && res.code === 1 && res.result) {
            this.cameraList = res.result;
          }
        })
        .catch(error => {
          console.log(error);
        });
    },
    // 获取表格数据
    FetchFindByPage(response) {
      this.tableData = [];
      this.loading = true;
      let params = cloneDeep(response);
      if (params.onlineStatus == "") {
        params.onlineStatus = -1;
      }
      FetchCameraManageList(params)
        .then(response => {
          if (
            response.result &&
            response.result.data &&
            Array.isArray(response.result.data)
          ) {
            this.tableData = response.result.data;
            this.total = response.result.totalRecords;
          }
          this.loading = false;
        })
        .catch(error => {
          this.loading = false;
          console.log(error);
        });
    },
    // 选择仓库
    handleSelStorage(val) {
      if (this.cameraObj.usingObjList.length > 0) {
        this.cameraObj.usingObjList[0].companyId =
          val.length > 0 ? val[0].id : 0;
      } else {
        this.cameraObj.usingObjList.push({ companyId: 0, companyName: "" });
      }
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        pageParamVO: {
          curPage: this.curPage,
          pageSize: this.pageSize,
          sortDir: "desc",
          sortIndx: "cameraName"
        }
      });
    },
    // 选择摄像头
    handleSelectCamera(val) {
      this.formExtend.forms.cameraIdList = [];
      val.forEach(v => {
        this.formExtend.forms.cameraIdList.push(Number(v.id.split("_")[1]));
      });
    },
    // 是否查询
    handleIsSearch() {
      this.isSearch = !this.isSearch;
      this.$nextTick(() => {
        this.resizeListener();
      });
    },
    // 查询数据
    handlesSubmitForm() {
      this.curPage = 1;
      this.FetchFindByPage(this.mergeObj());
    },
    //排序
    sortable(row) {
      let params = this.mergeObj();
      //判断升序还是降序
      if (row.order === "ascending") {
        params.pageParamVO.sortDir = "ASC";
      } else if (row.order === "descending") {
        params.pageParamVO.sortDir = "DESC";
      }
      params.pageParamVO.sortIndx = row.prop;
      //重新加载数据
      this.FetchFindByPage(params);
    },
    //重置
    handleResetForm() {
      this.$refs.cameraTreeSelect.multipleRemoveAll();
    },
    // 翻页
    handleCurrentChange(e) {
      this.curPage = e;
      this.FetchFindByPage(this.mergeObj());
    },
    // 设置每页多少条
    handleSizeChange(e) {
      this.pageSize = e;
      this.FetchFindByPage(this.mergeObj());
    },
    //导出
    async handleExportClick() {
      let params = cloneDeep(this.mergeObj());
      exportCamera(params).then(res => {
        // 导出
        exportXlsx(res, `摄像头管理.xls`);
      });
    },
    // 查看照片
    openCamera(row) {
      this.cameraObj = cloneDeep(row);
      this.oldCameraName = row.cameraName;
      this.dialogCameraVisible = true;
      this.$nextTick(() => {
        if (row.usingObjList.length > 0) {
          this.$refs.storageTreeSelect.setSelectList([
            Number(row.usingObjList[0].companyId)
          ]);
        }
      });
    },
    closeCamera() {
      this.cameraObj = {};
      this.dialogCameraVisible = false;
      this.$refs.camera.clearValidate();
      this.oldCameraName = "";
      this.$refs["storageTreeSelect"].multipleRemoveAll();
    },
    // 保存摄像头设置
    saveSetting(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (this.cameraObj.cameraName != this.oldCameraName) {
            this.checkIsExisCode();
          } else {
            this.saveCameraInfo();
          }
        } else {
          return false;
        }
      });
    },
    //验证是否重复
    async checkIsExisCode() {
      try {
        let _this_ = this;
        let params = JSON.parse(JSON.stringify(this.cameraObj));
        //企业名称、社会统一信用代码
        let promiseList = [];
        promiseList.push(
          cameraNameIsExist({
            cameraName: params.cameraName,
            cameraId: params.cameraId
          })
        );
        Promise.all(promiseList)
          .then(([res]) => {
            let cameraNameCheck = false;
            if (res === true) {
              cameraNameCheck = true;
            } else {
              // 判断企业名称是否重复
              cameraNameCheck = this.handleExist(res);
              if (!cameraNameCheck) {
                _this_.cameraNameMsg = res.message;
                _this_.$refs["camera"].validateField("cameraName");
                _this_.cameraNameMsg = "";
              }
            }
            //通过了才能保存
            if (cameraNameCheck) {
              _this_.saveCameraInfo();
            }
            return true;
          })
          .catch(err => {
            console.log(err);
          });
      } catch (err) {
        console.log(err);
      }
    },
    // 请求重复的处理
    handleExist(data) {
      if (data) {
        if (data.code) {
          return true;
        } else {
          return false;
        }
      }
    },
    // 重复校验方法
    checkExistFun(rule, value, callback, msg) {
      if (msg) {
        return callback(new Error(msg));
      } else {
        callback();
      }
    },
    async saveCameraInfo() {
      try {
        let params = {};
        params.cameraCode = this.cameraObj.cameraCode;
        params.cameraId = this.cameraObj.cameraId;
        params.cameraName = this.cameraObj.cameraName;
        params.corpId = this.cameraObj.companyId;
        params.threeLevelList = [
          {
            storageId: 0
          }
        ];
        if (this.cameraObj.usingObjList.length > 0) {
          params.threeLevelList[0].storageId = this.cameraObj.usingObjList[0].companyId;
        }
        console.log(params, params.threeLevelList[0].storageId);
        let res = await saveSettingCameraManage(params);
        if (res.code) {
          this.$message.success("保存成功");
          this.closeCamera();
          this.handlesSubmitForm();
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    },
    /*------------------------------导入-----------------------------------*/
    openImport() {
      this.dialogImportVisible = true;
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}

.title-section {
  padding: 15px 0 10px;
}

.table-section {
  height: 200px;
}

.pagination-section {
  padding: 10px 0;
}

.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}

.links {
  color: #0000ff;
  cursor: pointer;
}

/deep/ .el-button--primary {
  .e6-icon-export_line,
  .e6-icon-set-up_line {
    color: #fff !important;
  }
}
/deep/ .el-badge__content {
  height: 14px;
  line-height: 14px;
  padding: 0 4px;
}
/deep/ .el-badge__content.is-fixed {
  top: 7px;
}
/deep/ .dialog-css {
  .el-dialog {
    .el-dialog__title {
      font-size: 16px;
    }
    .el-dialog__body {
      padding: 20px;
      .el-form-item__label {
        color: #949494;
      }
      .el-input {
        width: calc(100% - 90px) !important;
      }
    }
    .el-select {
      width: 100%;
    }
    .el-dialog__header {
      padding: 10px;
      background-color: #efefef;
      text-align: left;
      .el-dialog__headerbtn {
        top: 15px;
      }
    }
  }
}
</style>
